import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IActivationSp, IScenarioPreprogramme } from '../../_models/ScenarioPreprogramme';
import { BaseHubService } from './base-hub.service';
import { MessageService } from '../local/message.service';
import { ConfigService } from '../local/config.service';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../_store/mainStoreState';
import { IBaseObject } from '../../_models/BaseObject';
import { setScenarioPreprogrammesAction } from '../../_store/ScenarioPreprogrammeStore/scenario-preprogramme.store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpService extends BaseHubService<IScenarioPreprogramme> {
  constructor(private store: Store<MainStoreState>, http: HttpClient, messageService: MessageService, configService: ConfigService) {
    super('scenarios-preprogrammes', 'hubs/spHub', 'Scénarios préprogrammés', http, messageService, configService);
  }

  activate(activation: IActivationSp): Observable<boolean | undefined> {
    return this.http.post<boolean | undefined>(this.baseUrl + '/activation-etapes', activation).pipe(
      catchError((error) => this.handleError(error)),
      map((res) => (res === undefined ? undefined : true))
    );
  }

  exists(numeroPGM: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/numero-pgm/${numeroPGM}`).pipe(
      catchError((error) => {
        console.error(error);
        return of(error.status === 409);
      }),
      map((res) => res == null ? false : res)
    );
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
    this.store.dispatch(
      setScenarioPreprogrammesAction({
        payload: data as IScenarioPreprogramme[],
      })
    );
  }
}
